
import CoinViewer from './coinviewer'

export default CoinViewer;